import React from "react";
import WorkflowHelpBanner from "./WorkflowHelpBanner";

export default function PipelineFilterBar({
  chips = [],
  onClearAll,
  workflowStage,
  compactHelp = false,
}) {
  return (
    <div className="mb-3">
      {workflowStage && (
        <WorkflowHelpBanner stage={workflowStage} compact={compactHelp} />
      )}
      {chips.length > 0 && (
        <div className="d-flex flex-wrap align-items-center gap-2">
          <span className="text-muted small me-1">Showing context:</span>
          {chips.map((chip) => (
            <span key={chip.key} className="badge bg-primary-transparent text-primary border">
              {chip.label}
            </span>
          ))}
          {onClearAll && (
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={onClearAll}
            >
              Clear context
            </button>
          )}
        </div>
      )}
    </div>
  );
}
